import ApiServices from "@/services/uteis/ApiServices.js";
import route from "@/libs/endPoint/avaliacaoinstitucional/AvaliacaoInstitucionalRoutes";
//import store from "@/store/index.js";
class AvaliacaoInstitucionalServices {
  validarUsuarioQuestionario(params) {
    try {
      const url = route.validarUsuario;
      return ApiServices.post(url, params);
    } catch (error) {
      console.error("Erro ao validar usuário para o questionário:", error);
      throw error;
    }
  }

  async questiuonariosServidoresAvaliacao() {
    try {
      const url = route.questionariosServidores;
      const { data } = await ApiServices.get(url, {});
      return data;
    } catch (error) {
      console.error("Error loading institution list:", error);
      throw error;
    }
  }
}
export default new AvaliacaoInstitucionalServices();
